"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressAutoComplete = void 0;
var _mui = require("@ori-ui/mui");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _Localization = require("../Localization");
var _constants = require("../constants");
var _defaultTranslations = require("../constants/defaultTranslations");
var _useAddressAutocomplete = require("../hooks/useAddressAutocomplete");
var _TranslationKey = require("../models/TranslationKey");
var _AddressOption = require("./AddressOption");
var _jsxRuntime = require("react/jsx-runtime");
const AddressAutoComplete = props => {
  const {
    name,
    country,
    maxResults = _constants.MAX_SEARCH_OPTIONS,
    setAddressToForm,
    minSearchLength = 3,
    searchOptions,
    fields
  } = props;
  const {
    watch,
    formState: {
      errors
    },
    reset
  } = (0, _reactHookForm.useFormContext)();
  const values = watch();
  const api = (0, _globalApiClientReact.useApiClient)();
  const allowedAddressField = searchOptions.allowedSearchResults.map(item => item.toLowerCase());
  const hasFieldError = allowedAddressField.filter(item => Object.keys(errors).includes(item));
  const {
    inputText,
    suggestions,
    isOpen,
    selectedValue,
    hasError,
    handleInputChange,
    onSelectOption,
    onChange,
    setOpen,
    handleEditAddress
  } = (0, _useAddressAutocomplete.useAddressAutocomplete)({
    country,
    minSearchLength,
    maxResults,
    api,
    setAddressToForm,
    reset,
    values,
    searchOptions,
    hasFieldError,
    fields
  });
  const title = _Localization.AddressHintMapper.getLocalizationKey(name ?? '');
  const helperText = hasError ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormHelperText, {
    error: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      defaultMessage: _defaultTranslations.defaultTranslations.errorSearchAddressAutocomplete,
      id: _TranslationKey.TranslationKey.errorSearchAddressAutocomplete
    })
  }) : title;
  const getNoOptionsLabel = () => {
    if (inputText.length < 3) {
      return _TranslationKey.TranslationKey.typeAtLeastThreeCharacters;
    }
    return suggestions.length === 0 ? _TranslationKey.TranslationKey.noSuggestions : null;
  };
  const noOptionsLocalization = getNoOptionsLabel();
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
  const noOptionsText = noOptionsLocalization ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
    defaultMessage: noOptionsLocalization,
    id: noOptionsLocalization
  }) : null;
  (0, _react.useEffect)(() => {
    handleEditAddress(fields);
  }, [fields, handleEditAddress]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
    namespace: _defaultTranslations.translationsNamespace,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
      mb: 3,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Autocomplete, {
        id: "address-autocomplete",
        options: suggestions,
        getOptionLabel: option => option?.addressSummary ?? '',
        filterOptions: options => options,
        open: isOpen,
        onInputChange: handleInputChange,
        onChange: onChange,
        inputValue: inputText,
        value: selectedValue,
        renderInput: params => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.TextField, {
          ...params,
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _defaultTranslations.defaultTranslations.searchAddressAutocompleteV2,
            id: _TranslationKey.TranslationKey.searchAddressAutocompleteV2
          }),
          required: true,
          helperText: helperText,
          sx: {
            mb: 0
          }
        }),
        renderOption: (_props, suggestion) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddressOption.AddressOption, {
          suggestion: suggestion,
          onSelect: onSelectOption
        }),
        onOpen: () => setOpen(true),
        onClose: () => setOpen(false),
        noOptionsText: noOptionsText
      })
    })
  });
};
exports.AddressAutoComplete = AddressAutoComplete;
//# sourceMappingURL=AddressAutoComplete.js.map